//View Keys
export default {
    fleet_export_modal_pdf_title: "Exportar Columnas",
    fleet_export_modal_pdf_message: "Puede seleccionar maximo {{number}} columnas a exportar en el formato PDF"
};